import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';

const Terms = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={t('Όροι Χρήσης', 'Terms of Use')}
        description={t('Όροι χρήσης της ιστοσελίδας TFT - Tesco Food Technology.', 'Terms of use for TFT - Tesco Food Technology website.')}
      />
      <Navigation />
      
      <main className="flex-1 py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold mb-8">
            {t('Όροι Χρήσης', 'Terms of Use')}
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Αποδοχή Όρων', 'Acceptance of Terms')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Με την πρόσβαση και τη χρήση αυτού του ιστότοπου, αποδέχεστε και συμφωνείτε να δεσμεύεστε από τους όρους και τις προϋποθέσεις χρήσης.',
                  'By accessing and using this website, you accept and agree to be bound by the terms and conditions of use.'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Χρήση της Υπηρεσίας', 'Use of Service')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Συμφωνείτε να χρησιμοποιείτε τον ιστότοπο μόνο για νόμιμους σκοπούς και με τρόπο που δεν παραβιάζει τα δικαιώματα τρίτων.',
                  'You agree to use the website only for lawful purposes and in a way that does not infringe the rights of third parties.'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Πνευματικά Δικαιώματα', 'Intellectual Property')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Όλο το περιεχόμενο αυτού του ιστότοπου, συμπεριλαμβανομένων κειμένων, γραφικών, λογοτύπων και εικόνων, είναι ιδιοκτησία της TFT - Tesco Food Technology S.A.',
                  'All content on this website, including text, graphics, logos and images, is the property of TFT - Tesco Food Technology S.A.'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Περιορισμός Ευθύνης', 'Limitation of Liability')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Η TFT - Tesco Food Technology S.A. δεν φέρει ευθύνη για τυχόν άμεσες, έμμεσες ή παρεπόμενες ζημίες που προκύπτουν από τη χρήση αυτού του ιστότοπου.',
                  'TFT - Tesco Food Technology S.A. is not liable for any direct, indirect or consequential damages arising from the use of this website.'
                )}
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
